import { createFileRoute } from "@tanstack/react-router";
import CollaboratorsPage from "@/pages/CollaboratorsPage";

export const Route = createFileRoute("/_app/settings/collaborators")({
  component: CollaboratorsPage,
});
